import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { AuthProvider } from './app/auth';
import { PwaUpdateBanner } from './app/pwa';
import { ThemeProvider } from './app/theme';
import { ToastProvider } from './app/toast';
import { ErrorBoundary } from './components/ErrorBoundary';
import './styles/app.css';

if (typeof window !== 'undefined') {
  (window as any).taskflowDesktop?.maximize?.();
}

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element #root not found');

createRoot(rootElement).render(
  <StrictMode>
    <ErrorBoundary>
      <ThemeProvider>
        <ToastProvider>
          <BrowserRouter>
            <AuthProvider>
              <App />
              <PwaUpdateBanner />
            </AuthProvider>
          </BrowserRouter>
        </ToastProvider>
      </ThemeProvider>
    </ErrorBoundary>
  </StrictMode>,
);
